import React from "react";
import { IconProps } from "@/components/Icon";
interface MobileChatIconProps extends Omit<IconProps, "children"> {}

export const MobileChatIcon = ({ ...props }: MobileChatIconProps) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 18H13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 13V19C17 20.1046 16.1046 21 15 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 9V10.4893C13.9964 10.6857 14.1082 10.8659 14.2858 10.9498C14.4633 11.0338 14.6736 11.0058 14.823 10.8783L17 9H19.1818C20.186 9 21 8.18597 21 7.18182V3.81818C21 2.81403 20.186 2 19.1818 2H12.8182C11.814 2 11 2.81403 11 3.81818V7.18182C11 8.18597 11.814 9 12.8182 9H14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
